module.exports = __webpack_public_path__ + "static/media/login-gradient-bg.da931d0f.png";